"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ListItem = _interopRequireDefault(require("../ListItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function List(props) {
  var items = props.items,
      children = props.children,
      activeItem = props.activeItem,
      _onClick = props.onClick,
      className = props.className,
      selectable = props.selectable,
      itemClassName = props.itemClassName,
      square = props.square,
      borderless = props.borderless,
      ListItemProps = props.ListItemProps;
  var parentClassName = (0, _classnames.default)('flex flex-col bg-gray-100', className);
  return _react.default.createElement("div", {
    className: parentClassName
  }, children ? children : items.map(function (item, index) {
    var computedClassName = (0, _classnames.default)({
      'rounded-t': index === 0 && !square,
      'rounded-b': index === items.length - 1 && !square,
      'bg-primary text-white': activeItem.value === item.value,
      itemClassName: itemClassName
    });
    return _react.default.createElement(_ListItem.default, _extends({
      selectable: selectable,
      borderless: borderless,
      key: item.value,
      onClick: function onClick() {
        return _onClick(item);
      },
      className: computedClassName
    }, ListItemProps), item.label);
  }));
}

List.propTypes = {
  className: _propTypes.default.string,
  itemClassName: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  children: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func,
  activeItem: _propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  }),
  selectable: _propTypes.default.bool,
  square: _propTypes.default.bool,
  borderless: _propTypes.default.bool,
  ListItemProps: _propTypes.default.object
};
List.defaultProps = {
  children: null,
  className: '',
  activeItem: {},
  itemClassName: '',
  onClick: function onClick() {},
  selectable: false,
  square: false,
  borderless: false,
  ListItemProps: {}
};

var _default = _react.default.memo(List);

exports.default = _default;